import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { FeldUnterkategoriesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [FeldUnterkategoriesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class FeldUnterkategoriesServiceModule {}
